import Vue from 'vue'
import Router from 'vue-router'

import mobileIndex from '@/views/mobile/index'
import pcIndex from '@/views/pc/index'

Vue.use(Router)
// const isIndex = store.state.common.isIndex
// 判断打开链接的终端类型  mobile(移动端)、pc(pc端) 
var terminalType = (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) ? 'mobile' : 'pc';
var index = (terminalType == 'pc' ? pcIndex : mobileIndex)
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/index/game',
      name: 'game',
      component: () => import('@/views/mobile/game')
    },
    {
      path: '/gift',
      name: 'gift',
      component: () => import('@/views/mobile/gift')
    },
    {
      path: '/gift/game',
      name: 'giftGame',
      component: () => import('@/views/mobile/game')
    },
    {
      path: '/integral',
      name: 'integral',
      component: () => import('@/views/mobile/integral')
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/mobile/user')
    },
    {
      path: '/user/login',
      name: 'userLogin',
      component: () => import('@/views/mobile/user')
    },
    {
      path: '/user/userGame',
      name: 'userGame',
      component: () => import('@/views/mobile/userGame')
    },
    {
      path: '/user/userGift',
      name: 'userGift',
      component: () => import('@/views/mobile/userGift')
    },
    {
      path: '/user/userMessage',
      name: 'userMessage',
      component: () => import('@/views/mobile/userMessage')
    },
    {
      path: '/user/userAccount',
      name: 'userAccount',
      component: () => import('@/views/mobile/userAccount')
    },
    {
      path: '/user/service',
      name: 'service',
      component: () => import('@/views/mobile/service')
    },
    {
      path: '/user/token',
      name: 'userToken',
      component: () => import('@/views/mobile/user')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js